import { render, staticRenderFns } from "./ZenSocialEmbed.vue?vue&type=template&id=61bb8db4"
import script from "./ZenSocialEmbed.vue?vue&type=script&lang=js"
export * from "./ZenSocialEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports